import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../admin/admin.service';
import { Options } from '../../datatools-settings/duplikit-options/duplikit-options-config';
import { DuplikitOptionsService } from '../../datatools-settings/duplikit-options/duplikit-options.service';
import { MessageNotificationService } from '../../shared/services/message-notification.service';

@Component({
  selector: 'app-dry-run-warning',
  templateUrl: './dry-run-warning.component.html',
  imports: [
    NgClass
  ],
  styleUrls: ['./dry-run-warning.component.scss']
})
export class DryRunWarningComponent implements OnInit {
  options: Options = new Options;
  isInLiteMode: boolean;

  constructor(
      private duplikitOptionsService: DuplikitOptionsService,
      private adminService: AdminService,
      private messageNotificationService: MessageNotificationService
  ) { }

  saveDryRun(): void {
    this.options.isDryRun = !this.options.isDryRun;
    const optionsSubscription = this.duplikitOptionsService.setOptions(this.options).subscribe(() => {
      this.messageNotificationService.warning('Dry Run Disabled', 'Duplicate merging is now enabled.');
    }, (error) => {
      this.messageNotificationService.error('There was an error updating the settings', error.message);
      console.log(error);
    }, () => optionsSubscription.unsubscribe());
  }

  ngOnInit(): void {
    this.duplikitOptionsService.getOptions().subscribe(options => {
      this.options = options;
    });
    this.isInLiteMode = this.adminService.isInLiteMode();
  }

}
